const PRE = 'DinamicForm';

export const SALVAR = PRE + 'SALVAR';
export const LISTAR = PRE + 'LISTAR';


// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/actionTypes.js